import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Col, Form, Row, Table } from 'react-bootstrap';
import Select from 'react-select';
import { IoMdClose } from 'react-icons/io';
import debounce from 'lodash/debounce';
import { toWords } from 'number-to-words';
import CommonDcFields from '../../DC/CommonDcFields';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

function SrPDCreate() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [invoicedate, setinvoicedate] = useState('');
  const [invoiceno, setinvoiceno] = useState('');
  const [sono, setsono] = useState('');
  const [sodate, setsodate] = useState('');
  const [buyerorderno, setbuyerorderno] = useState('');
  const [buyerorderdate, setAmendmentdate] = useState('');
  const [deliverynoteno, setdeliverynoteno] = useState('');
  const [deliverynotedate, setdeliverynotedate] = useState('');
  const [destination, setdestination] = useState('');
  const [dispatchthrough, setdispatchthrough] = useState('');
  const [reference, setreference] = useState('');
  const [termsofdelivery, settermsofdelivery] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
  const [rows, setRows] = useState([]);
  const [commonFormData, setCommonFormData] = useState({});

  // Calculation state
  const [packingandforwardingpercent, setpackingandforwardingpercent] = useState(0);
  const [freightpercent, setfreightpercent] = useState(0);
  const [gstpercent, setgstpercent] = useState(18);
  const [calculationSummary, setCalculationSummary] = useState({
    nettotal: 0,
    pAndF: 0,
    freight: 0,
    subtotal: 0,
    gst: 0,
    grandtotalinr: 0
  });

  const unitOptions = [
    { value: "", label: "Select UOM" },
    { value: "bot", label: "Bot" },
    { value: "ctn", label: "Ctn" },
    { value: "days", label: "Days" },
    { value: "ft", label: "Ft" },
    { value: "hrs", label: "Hrs" },
    { value: "kg", label: "Kg" },
    { value: "ltr", label: "Ltr" },
    { value: "mtr", label: "Mtr" },
    { value: "nos", label: "Nos" },
    { value: "pil", label: "Pil" },
    { value: "pkt", label: "Pkt" },
    { value: "set", label: "Set" },
    { value: "pcs", label: "Pcs" }
  ];




  const [salesreturnno, setsalesreturnno] = useState('');
  const [salesreturndate, setsalesreturndate] = useState('');
  const [enquiryValidationMsg, setEnquiryValidationMsg] = useState('');
  const [isEnquiryValid, setIsEnquiryValid] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);


  const checksalesreturnno = async (number) => {
    if (!number) {
      setEnquiryValidationMsg('');
      setIsEnquiryValid(false);
      return;
    }


    if (!/^[A-Za-z0-9-]+$/.test(number)) {
      setEnquiryValidationMsg('❌ Only alphanumeric characters and hyphens are allowed');
      setIsEnquiryValid(false);
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}salesReturn/check/${number}`, {
        headers: authHeader(),
      });

      if (response.data === true) {
        setEnquiryValidationMsg('❌ This sales return number already exists.');
        setIsEnquiryValid(false);
      } else if (response.data === false) {
        setEnquiryValidationMsg('✅ This sales return number is available.');
        setIsEnquiryValid(true);
      } else {
        setEnquiryValidationMsg('Unexpected response from server.');
        setIsEnquiryValid(false);
      }
    } catch (error) {
      console.error("Error checking enquiry number:", error);
      setEnquiryValidationMsg('❌ Error validating sales return number.');
      setIsEnquiryValid(false);
    }
  };


  useEffect(() => {
    const debouncedCheck = debounce(() => {
      checksalesreturnno(salesreturnno);
    }, 400);

    debouncedCheck();

    return () => debouncedCheck.cancel();
  }, [salesreturnno]);

  // Function to format numbers with commas
  const formatNumberWithCommas = (num) => {
    if (num === null || num === undefined) return '0.00';
    return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const numberToWordsWithRupees = (num) => {
    const amount = Math.round(num);
    const words = toWords(amount);

    // Capitalize first letter of each word
    const capitalizedWords = words.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');

    return `${capitalizedWords} Rupees Only`;
  };;

  const handleCommonFormData = (data) => {
    setCommonFormData(data);
    if (data.customerDetails) {
      setfreightpercent(parseFloat(data.customerDetails.freight) || 0);
      setpackingandforwardingpercent(parseFloat(data.customerDetails.packingandforwarding) || 0);
    }
  };

  useEffect(() => {
    calculateTotals();
  }, [rows, packingandforwardingpercent, freightpercent, gstpercent, commonFormData.customerDetails]);

  const calculateTotals = () => {
    const nettotal = rows.reduce((sum, row) => {
      const quantity = parseFloat(row.quantity) || 0;
      const unitrate = parseFloat(row.unitrate) || 0;
      return sum + (quantity * unitrate);
    }, 0);

    const pAndF = nettotal * (packingandforwardingpercent / 100);
    const freight = nettotal * (freightpercent / 100);
    const subtotal = nettotal + pAndF + freight;
    const gst = subtotal * (gstpercent / 100);
    const grandtotalinr = subtotal + gst;

    setCalculationSummary({
      nettotal,
      pAndF,
      freight,
      subtotal,
      gst,
      grandtotalinr
    });
  };

  const handleProductSearchChange = debounce((inputValue) => {
    setProductSearch(encodeURIComponent(inputValue || " "));
  }, 300);

  const getProductData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}product/page/ptype/0/10/desc/id/2/Finished,Raw Material, Semi Finished,Services/${productSearch}`,
        { headers: authHeader() }
      );

      const products = response.data?.Index || response.data?.data || [];
      const mapped = products.map(product => ({
        value: product.id,
        label: `${product.description}  - ${product.serialnumber} - ${product.partno}`,
        description: product.description,
        itemcode: product.itemcode,
        hsnsacno: product.hsnsacno,
        partno: product.partno,
        serialnumber: product.serialnumber,
        modelnumber: product.modelnumber,
        tagnumber: product.tagnumber,
        moc: product.moc,
        uom: product.unitofmeasurement || unitOptions[0].value,
      }));

      setProductOptions(mapped);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  useEffect(() => {
    getProductData();
  }, [productSearch]);

  const handleProductChange = (selectedOption) => {
    if (!selectedOption) return;
    setSelectedProduct(selectedOption);

    const newRow = {
      description: selectedOption.description,
      value: selectedOption.value,
      label: selectedOption.label,
      quantity: '',
      unitrate: '',
      amount: 0,
      partno: selectedOption.partno,
      hsnsacno: selectedOption.hsnsacno,
      itemcode: selectedOption.itemcode,
      serialnumber: selectedOption.serialnumber,
      modelnumber: selectedOption.modelnumber,
      tagnumber: selectedOption.tagnumber,
      moc: selectedOption.moc,
      uom: selectedOption.uom || unitOptions[0].value,
      productremarks: "",
    };

    setRows([...rows, newRow]);
  };

  const handleRowChange = (index, key, value) => {
    const updatedRows = [...rows];
    updatedRows[index][key] = value;

    if (key === 'quantity' || key === 'unitrate') {
      const quantity = parseFloat(updatedRows[index].quantity) || 0;
      const unitrate = parseFloat(updatedRows[index].unitrate) || 0;
      updatedRows[index].amount = quantity * unitrate;
    }

    setRows(updatedRows);
  };

  const removeRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEnquiryValid) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please enter a valid sales number before submitting.',
      });
      return;
    }
    const {
      customer,
      customerDetails,
      customerMultipleAddress,
      branch,
      warehouse,
      shipTo,
      billTo,
    } = commonFormData;

    if (!customer || !customerMultipleAddress) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill the required details!',
        text: 'All fields marked with an asterisk are required.',
      });
      return;
    }

    const salesReturnItems = rows.map(row => ({
      product: { id: row.value },
      quantity: row.quantity,
      unitrate: row.unitrate,
      amount: row.amount,
      itemcode: row.itemcode || '',
      hsnsacno: row.hsnsacno || '',
      partno: row.partno || '',
      uom: row.uom || '',
      serialnumber: row.serialnumber || '',
      modelnumber: row.modelnumber || '',
      tagnumber: row.tagnumber || '',
      productremarks: row.productremarks || '',
      moc: row.moc || '',
    }));

    const formData = {
      salesReturnItems,
      salesreturntype: 'Pump Spare',
      salesreturncategory: 'Domestic',
      customer: { id: customer.value },
      contactno: customerDetails.contactno,
      contactperson: customerDetails.contactperson,
      email: customerDetails.email,
      customeraddress: { id: customerMultipleAddress?.value },
      shipto: { id: shipTo?.value },
      billto: { id: billTo?.value },
      branch: branch ? { id: commonFormData.branch.value } : null,
      warehouse: warehouse ? { id: commonFormData.warehouse.value } : null,
      invoicedate,
      salesreturndate,
      invoiceno,
      salesreturnno,
      termsofdelivery,
      sono,
      sodate,
      buyerorderno,
      buyerorderdate,
      deliverynoteno,
      deliverynotedate,
      destination,
      dispatchthrough,
      reference,
      packingandforwardingpercent,
      freightpercent,
      gstpercent,
      nettotal: calculationSummary.nettotal,
      grandtotalinr: calculationSummary.grandtotalinr,
      freight: customerDetails.freight,
      packingandforwarding: customerDetails.packingandforwarding,
      paymentterm: customerDetails.paymentterm
    };

    try {
      await axios.post(`${BASE_URL}salesReturn/save`, formData, {
        headers: authHeader()
      });
      Swal.fire({ icon: 'success', title: 'Success', text: ' Added successfully!' });
      navigate("/srindex/1");
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || 'Failed .' });
    }
  };

  return (
    <div className="container">
      <Form onSubmit={handleSubmit}>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Sales Return  No.: *</Form.Label>
              <Form.Control
                type="text"
                value={salesreturnno}
                onChange={e => {
                  setsalesreturnno(e.target.value);
                  setFormSubmitted(false);
                }}
                isInvalid={
                  (formSubmitted && !isEnquiryValid) ||
                  enquiryValidationMsg.includes('exists') ||
                  enquiryValidationMsg.includes('Error') ||
                  enquiryValidationMsg.includes('allowed')
                }
                required
              />
              {enquiryValidationMsg && (
                <Form.Control.Feedback type={
                  enquiryValidationMsg.includes('exists') ||
                    enquiryValidationMsg.includes('Error') ||
                    enquiryValidationMsg.includes('allowed') ?
                    "invalid" : "valid"
                }>
                  {enquiryValidationMsg}
                </Form.Control.Feedback>
              )}
              {formSubmitted && !isEnquiryValid && !enquiryValidationMsg && (
                <Form.Control.Feedback type="invalid">
                  Please enter a valid enquiry number
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Sales Return Date</Form.Label>
              <Form.Control
                type="date"
                name="salesreturndate"
                value={salesreturndate}
                onChange={(e) => setsalesreturndate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="invoiceno">
              <Form.Label>Invoice Number</Form.Label>
              <Form.Control
                type="text"
                value={invoiceno}
                onChange={(e) => setinvoiceno(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Sales Invoice Date</Form.Label>
              <Form.Control
                type="date"
                value={invoicedate}
                onChange={e => setinvoicedate(e.target.value)}
              />
            </Form.Group>
          </Col>

          {/* DC DETAILS */}
          <Col md={6}>
            <Form.Group controlId="deliverynoteno">
              <Form.Label>Delivery Note Number</Form.Label>
              <Form.Control
                type="text"
                value={deliverynoteno}
                onChange={(e) => setdeliverynoteno(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="deliverynotedate">
              <Form.Label>Delivery Note Date</Form.Label>
              <Form.Control
                type="date"
                value={deliverynotedate}
                onChange={(e) => setdeliverynotedate(e.target.value)}
              />
            </Form.Group>
          </Col>

          {/* SALES ORDER DETAILS */}
          <Col md={6}>
            <Form.Group controlId="sono">
              <Form.Label>Sales Order No.</Form.Label>
              <Form.Control
                type="text"
                value={sono}
                onChange={(e) => setsono(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="sodate">
              <Form.Label>Sales Order Date</Form.Label>
              <Form.Control
                type="date"
                value={sodate}
                onChange={(e) => setsodate(e.target.value)}
              />
            </Form.Group>
          </Col>

          {/* BUYER ORDER DETAILS */}
          <Col md={6}>
            <Form.Group controlId="buyerorderno">
              <Form.Label>Buyer Order No.</Form.Label>
              <Form.Control
                type="text"
                value={buyerorderno}
                onChange={(e) => setbuyerorderno(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="buyerorderdate">
              <Form.Label>Buyer Order Date</Form.Label>
              <Form.Control
                type="date"
                value={buyerorderdate}
                onChange={(e) => setAmendmentdate(e.target.value)}
              />
            </Form.Group>
          </Col>



          {/* DISPATCH INFO */}
          <Col md={6}>
            <Form.Group controlId="dispatchthrough">
              <Form.Label>Dispatch Through</Form.Label>
              <Form.Control
                type="text"
                value={dispatchthrough}
                onChange={(e) => setdispatchthrough(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="destination">
              <Form.Label>Destination</Form.Label>
              <Form.Control
                type="text"
                value={destination}
                onChange={(e) => setdestination(e.target.value)}

              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          {/* Common Fields */}
          <CommonDcFields
            onDataChange={handleCommonFormData}
          />
        </Row>

        <Row>
          {/* ADDITIONAL INFO */}
          <Col md={6}>
            <Form.Group controlId="termsofdelivery">
              <Form.Label>Delivery Term</Form.Label>
              <Form.Control
                type="text"
                value={termsofdelivery}
                onChange={(e) => settermsofdelivery(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group controlId="reference">
              <Form.Label>Other Reference</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={reference}
                onChange={(e) => setreference(e.target.value)}
              />
            </Form.Group>
          </Col>

        </Row>

        <Form.Group controlId="productSelect">
          <Form.Label>Select a Product</Form.Label>
          <Select
            value={selectedProduct}
            onInputChange={handleProductSearchChange}
            onChange={handleProductChange}
            options={productOptions}
            placeholder="Search or select product"
            isClearable
          />
        </Form.Group>

        <div className="table-responsive mt-3">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Product Description</th>
                <th>Serial No.</th>
                <th>Model No.</th>
                <th>Tag No.</th>
                <th>Part No.</th>
                <th>MOC</th>
                <th>HSN Code</th>
                <th>Product Code</th>
                <th>Quantity</th>
                <th>UOM</th>
                <th>Unit Rate</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {row.description}
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={row.productremarks}
                      onChange={(e) => handleRowChange(index, 'productremarks', e.target.value)}
                      placeholder="Remarks"
                    />
                  </td>
                  <td>{row.serialnumber}</td>
                  <td>{row.modelnumber}</td>
                  <td>{row.tagnumber}</td>
                  <td>{row.partno}</td>
                  <td>{row.moc}</td>
                  <td>{row.hsnsacno}</td>
                  <td>{row.itemcode}</td>
                  <td>
                    <Form.Control
                      type="number"
                      value={row.quantity}
                      onChange={(e) => handleRowChange(index, 'quantity', e.target.value)}
                    />
                  </td>
                  <td>
                    <Select
                      className='uom'
                      value={unitOptions.find(option => option.value === row.uom)}
                      onChange={(selected) => handleRowChange(index, 'uom', selected.value)}
                      options={unitOptions}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      value={row.unitrate}
                      onChange={(e) => handleRowChange(index, 'unitrate', e.target.value)}
                    />
                  </td>
                  <td>{formatNumberWithCommas(row.amount)}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => removeRow(index)}
                    >
                      <IoMdClose />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <hr />
        <br />
        <div className="table-responsive mt-3">
          <h4>Amount Calculation</h4>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Description</th>
                <th>Percentage</th>
                <th>Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Net Total</td>
                <td>-</td>
                <td>{formatNumberWithCommas(calculationSummary.nettotal)}</td>
              </tr>
              <tr>
                <td>Packing & Forwarding % :</td>
                <td>
                  <Form.Control
                    type="number"
                    value={packingandforwardingpercent}
                    onChange={(e) => setpackingandforwardingpercent(e.target.value)}
                    style={{ width: '80px' }}
                  />
                  {commonFormData.customerDetails?.packingandforwarding &&
                    <small className="text-muted"> (From customer: {commonFormData.customerDetails.packingandforwarding}%)</small>
                  }
                </td>
                <td>{formatNumberWithCommas(calculationSummary.pAndF)}</td>
              </tr>
              <tr>
                <td>Freight % :</td>
                <td>
                  <Form.Control
                    type="number"
                    value={freightpercent}
                    onChange={(e) => setfreightpercent(e.target.value)}
                    style={{ width: '80px' }}
                  />
                  {commonFormData.customerDetails?.freight &&
                    <small className="text-muted"> (From customer: {commonFormData.customerDetails.freight}%)</small>
                  }
                </td>
                <td>{formatNumberWithCommas(calculationSummary.freight)}</td>
              </tr>
              <tr>
                <td>Sub Total :</td>
                <td>-</td>
                <td>{formatNumberWithCommas(calculationSummary.subtotal)}</td>
              </tr>
              <tr>
                <td>GST % :</td>
                <td>
                  <Form.Control
                    type="number"
                    value={gstpercent}
                    onChange={(e) => setgstpercent(e.target.value)}
                    style={{ width: '80px' }}
                  />
                </td>
                <td>{formatNumberWithCommas(calculationSummary.gst)}</td>
              </tr>
              <tr>
                <td><strong>Grand Total :</strong></td>
                <td>-</td>
                <td><strong>{formatNumberWithCommas(calculationSummary.grandtotalinr)}</strong></td>
              </tr>
              <tr>
                <td colSpan="2"><strong>Grand Total in Words</strong></td>
                <td><em>{numberToWordsWithRupees(calculationSummary.grandtotalinr)}</em></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <button className="btn btn-primary mt-3" type="submit">SUBMIT</button>
      </Form>
    </div>
  );
}

export default SrPDCreate;